<template>
  <div class="wrapper">
    <Header />

    <!-- Banner -->
    <div class="innerbannerwrap">
      <div class="innerbanner">
        <h2 class="bannerHeadline">contact <span>us</span></h2>
      </div>
    </div>

    <!-- Get in Touch -->
    <section class="innerpage_all_wrap">
      <div class="container">
        <div class="row">
          <h2 class="heading">get in <span>touch</span></h2>
          <p class="headParagraph">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat quisquam
            reprehenderit, blanditiis nam debitis libero facilis illum repudiandae eveniet
            voluptatibus quibusdam illo ea nisi ipsa accusantium nobis animi asperiores quaerat.
          </p>

          <div class="innerWrapper">
            <ul class="contact_icon clearfix">
              <li>
                <a href="tel:+18002569876">
                  <i class="fa fa-phone"></i>
                  <span>+1 800-256-9876</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@soccerclub.com">
                  <i class="fa fa-envelope-o"></i>
                  <span>info@soccerclub.com</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fa fa-map-marker"></i>
                  <span>321/1 Bakers Street, Newwork</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Map and Contact Form -->
    <section class="map_wrapper clearfix">
      <div id="map-section"></div>
      <div class="container">
        <div class="row">
          <div class="contact_form">
            <h2 class="heading">contact us <span>by form</span></h2>
            <p class="headParagraph">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat quisquam
              reprehenderit, blanditiis nam debitis libero facilis illum repudiandae eveniet
              voluptatibus quibusdam illo ea nisi ipsa accusantium nobis animi asperiores quaerat.
            </p>

            <form class="formcontact clearfix" @submit.prevent="submitForm">
              <div class="form-group">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  v-model="form.phone"
                  type="text"
                  class="form-control"
                  placeholder="Phone"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  v-model="form.subject"
                  type="text"
                  class="form-control"
                  placeholder="Subject"
                  required
                />
              </div>
              <div class="form-group">
                <input
                  v-model="form.email"
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  required
                />
              </div>
              <div class="form-group1">
                <textarea
                  v-model="form.message"
                  class="form-control textas"
                  placeholder="Message"
                  required
                ></textarea>
              </div>
              <button type="submit" class="btn btn-red" id="send">Send Us</button>

              <div v-if="submitted" class="form-message">
                ✅ Your message has been sent successfully!
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

const form = ref({
  name: '',
  phone: '',
  subject: '',
  email: '',
  message: '',
})

const submitted = ref(false)

function submitForm() {
  console.log('Form submitted:', form.value)
  submitted.value = true

  // reset form
  form.value = { name: '', phone: '', subject: '', email: '', message: '' }
}
</script>

<style scoped>
.form-message {
  margin-top: 1rem;
  color: #28a745;
  font-weight: bold;
}
</style>
